import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  CircularProgress,
} from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/AircraftDetailDialog.css";

const AircraftDetailDialog = ({
  open,
  onClickSave,
  onClose,
  isLoading,
  editedFlightDetails,
  setEditedFlightDetails,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleAircraftSaveEdit = () => {
    if (isEditing) {
      onClickSave();
    } else {
      setIsEditing(true);
    }
  };

  const handleRegistrationNoOnChange = (event) => {
    setEditedFlightDetails({
      ...editedFlightDetails,
      aircraftRegistrationNumber: event.target.value,
    });
  };

  const handleMaxweightOnChange = (event) => {
    setEditedFlightDetails({
      ...editedFlightDetails,
      aircraftMaxTakeoffWeight: event.target.value,
    });
  };

  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "aircraft-detail-dialog-container",
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="aircraft-detail-dialog-close"
          onClick={onClose}
        />
        <div className="aircraft-detail-dialog-content">
          <div className="aircraft-detail-dialog-title">Aircraft Details</div>
          <div className="aircraft-detail-input-container">
            <label>Aircraft Type</label>
            <div className="aircraft-detail-non-editable-field">
              {editedFlightDetails.aircraftType}
            </div>
          </div>
          <div className="aircraft-detail-input-container">
            <label>Aircraft Registration Number</label>
            {isEditing ? (
              <input
                name="aircraft-registration-number"
                value={editedFlightDetails.aircraftRegistrationNumber}
                onChange={handleRegistrationNoOnChange}
                required
              />
            ) : (
              <div className="aircraft-detail-non-editable-field">
                {editedFlightDetails.aircraftRegistrationNumber}
              </div>
            )}
          </div>
          <div className="aircraft-detail-input-container">
            <label>Maximum Takeoff Weight (lbs)</label>
            {isEditing ? (
              <input
                type="number"
                name="takeoff-weight"
                min="0"
                value={editedFlightDetails.aircraftMaxTakeoffWeight}
                onChange={handleMaxweightOnChange}
              />
            ) : (
              <div className="aircraft-detail-non-editable-field">
                {editedFlightDetails.aircraftMaxTakeoffWeight}
              </div>
            )}
          </div>
          <Button
            variant="contained"
            className={isEditing ? "save" : "edit"}
            onClick={!isLoading ? handleAircraftSaveEdit : null}
            endIcon={
              isLoading ? <CircularProgress size={30} color="inherit" /> : null
            }
          >
            {isEditing ? "Save" : "Edit"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AircraftDetailDialog;
